import * as actionTypes from './actionTypes';
import * as actions from './index';

export const workflowSend = (workflow, id, type = 'CLIP', params = null) => {
	console.log(workflow, id, type, params);
    return (dispatch => {
        //dispatch(worklowSendStart());
		dispatch({ type: actionTypes.WORKFLOW_SEND_START });
        window.flow.workflowSend(workflow, id, type, params).then(res => {
            //dispatch(workflowSendSuccess(res));
			dispatch({ type: actionTypes.WORKFLOW_SEND_SUCCESS });
        }).catch(res => {
            //dispatch(worflowSendFail(res.message));
			dispatch({ type: actionTypes.WORKFLOW_SEND_FAIL });
            dispatch(actions.applicationError(res.message));
        })
    })
} 